import React, { useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Row, Spinner } from 'reactstrap';
import { TableStriped } from '../../../../components/tables/TableStriped';
import { ModalAnalytes } from '../../../../components/micro/analytes/ModalAnalytes';
import { FormAnalytes } from '../../../../components/micro/analytes/FormAnalytes';
import { ModalTestFormula } from '../../../../components/micro/analytes/ModalTestFormula';
import { ModalRange } from '../../../../components/micro/analytes/ModalRange';
import { ModalOrderAnalytes } from '../../../../components/micro/analytes/ModalOrderAnalytes';
import { Modal } from 'react-morphing-modal';
import { ModalComplex } from '../../../../components/micro/analytes/ModalComplex';
import 'react-morphing-modal/dist/ReactMorphingModal.css';
import { ModalOrderPrintAnalytes } from '../../../../components/micro/analytes/FormsTypeAnalytes/ModalOrderPrintAnalytes';
import Breadcrumb from '../../../../layout/breadcrumb'
import { useDetectedActivity } from '../../../../hooks/exams/useDetectedActivity';
import './StyleExam.css';
import { useHistory } from 'react-router-dom';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { GlobalReferenceValue } from './GlobalReferenceValue';
import { useExam } from '../../../../hooks/micro/useExam';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';

export const CreateExam = () => {

    const {
        analytes, loadingAnalytes, exam, analytesGroup, analytesGroupPrint, groupAnalytes, typeAnalytes, typePrecodedTexts, units, unitsTo,
        isOpen, toggle, loading, modal, toggleModal, nameAnalyte, loadingModal,
        handleInputChange, validaciones, methodActive, validateFormula,
        name, app_code, code, id_analyte_group, name_analyte_group, id_type_analyte, id_info_analyte, print, required, id_type_precoded_text, integers, decimals, id_unit, id_unit_to, compute, check_compute, replace, id_exam, loinc_num,
        addAnalyte, removeAnalyte, saveAnalytes, deleteAnalyte, handleEdit, editAnalyte, backCreate, changeUnit, validarFormula, resetValidarFormula,
        toggleTest, modalTest, loadingTest, testearFormula,
        init_range, end_range, value, increment, handleInputTest, resetTest, results, resetResults, handleModalTest,
        handleFullModal, modalProps, modalFullRef,
        gender, init_value, end_value, years_from, months_from, days_from, years_to, months_to, days_to, text_range, validacionesRange, method, methods,
        handleInputRange, resetRange, precodedTexts, listRanges, addAnalyteNumberRange, removeAnalyteNumberRange, saveTempAnalytesNumberRanges, editAnalyteNumberRange,
        id_analyte_age_gender_range, handleInputRangePrecoded,
        listRangesPrecoded, addRangePrecoded, saveTempRangePrecoded, removeRangePrecoded, editRangePrecoded, saveEditRangePrecoded, methodActiveRangePrecoded, backToCreateRangePrecoded,
        saveEditAnalyteRangeNumber, methodActiveRange, backToCreateRange, loincState,
        handleModalOrder, modalOrder, loadingOrder, saveOrderAnalytes,
        handleModalOrderPrint, modalOrderPrint, loadingOrderPrint, saveOrderPrintAnalytes,
        activeModal, analytesAvailables, refreshFormComplex, responseComplexText, refreshResultComplex, preSavedFormComplex, analytesComplex, exams,
        saveTempAnalytesNumberAlerts, listReferenceValues,
        handleValueBold, handleValueItalics, handleValueUnderline, handleValueFormatTransform, valueBold, valueItalics, valueUnderline, valueFormatTransform,
        selectedInfoAnalytes, infoAnalytes, handleValueInfoAnalyte,
        selectedInfoCharacteristics, infoCharacteristics, handleValueInfoCharacteristics,
        selectedExamSimple, simpleExams, handleValueExamSimple,
        selectedAnalyteImport, analytesFromExam,
        saveTempAnalytesTextAlerts, listReferenceTexts,
        tabTypeAnalyte, toggleTypeAnalyte,
        options, onChange, data, handleChangeTextP, prueba, selected, savePrecodText,
        // global reference
        viewGlobalReferenceValue, handleViewGlobalReference,
        morphologys, bacteriums, bacteriumsOptions, bacteriumsSelected, handleValueGram, handleValueIdBacterium, print_graph
    } = useExam(false, true);
   // const handleEdit = (id_analyte, external = false) => {
    //getMethods


    const { innerHeight: height } = window;

    const history = useHistory();
    const txtsection = localStorage.getItem('TextAS');
    useDetectedActivity(60000, 10000);


    
   const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const headerStyleAnalytes = {
        backgroundColor: "#1593c1",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyleAnalytes = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyleAnalytes = {
        ...cellStyleAnalytes,
        textAlign: "center",
    };

    const [expandedRowsAnalytes, setExpandedRowsAnalytes] = useState(null);

    const actionsAnalytes = (rowData) => {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                 <button
                    onClick={() => {
                        setExpandedRowsAnalytes(prev => {
                            const id = rowData.id_analyte;

                            if (prev?.[id]) {
                                return null;
                            }

                            return {
                                [id]: true
                            };
                        });
                    }}
                    title="Serie y folio para facturas"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#FF5722"
                    }}
                >
                    <i className="fa fa-eye"></i>
                </button>

                <Button
                    size="sm"
                    onClick={() => handleEdit(rowData.id_analyte)}
                    title="Editar sucursal"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => removeAnalyte(rowData.id_analyte)}
                    title="Serie y folio para facturas"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>

                );
    };
    
    const rowExpansionTemplateAnalytes = (data) => {
        return (
            <div className="p-2">
                <div className="row">

                    <div className="col-md-4">
                        <strong>Característica:</strong>{" "}
                        {data.name || "-"}
                    </div>

                    <div className="col-md-4">
                        <strong>Tipo de captura:</strong>{" "}
                        {data.name_type_precoded_text || "-"}
                    </div>

                    <div className="col-md-4">
                        <strong>AppCode:</strong>{" "}
                        {data.app_code || "-"}
                    </div>

                </div>
            </div>
        );
    };
    
    return (
        <> 
            <Row>
                <Col className='analyte-col container-global-zoom' id="accordionoc" xs="12" sm="8" md="8" lg="4" xl="4">
                    <div className="sticky-analyte-header">    
                     <Card className="shadow">
                        <CardHeader className="integration-card-header p-3">
                            {
                                methodActive === "create" ?
                                    <label className='labelIntegracionAnalyte'>Integración de resultados </label> :
                                    (
                                        <>
                                            <Col sm="5"> 
                                                <h7>Edición de analito</h7>
                                            </Col>

                                                <Col sm="7">
                                                <i className="fa fa-long-arrow-left"></i><h7 style={{ cursor: "pointer" }} onClick={backCreate}>&nbsp;  Regresar a creación</h7> <br />

                                            </Col>
                                        </>
                                    )
                            }
                        </CardHeader>
                        <div className="analyte-scroll">
                        <FormAnalytes
                            {...{
                                methodActive, addAnalyte, editAnalyte, changeUnit, validarFormula, resetValidarFormula,
                                name, app_code, code, id_analyte_group, name_analyte_group, id_type_analyte, id_info_analyte, print, required, id_type_precoded_text, integers, decimals, id_unit, id_unit_to, compute, replace, check_compute, id_exam, loinc_num,
                                groupAnalytes, typeAnalytes, typePrecodedTexts, units, unitsTo,
                                handleInputChange, validaciones, validateFormula, handleModalTest,
                                handleFullModal, modalFullRef, loincState,
                                handleValueBold, handleValueItalics, handleValueUnderline, handleValueFormatTransform, valueBold, valueItalics, valueUnderline, valueFormatTransform,
                                selectedInfoAnalytes, infoAnalytes, handleValueInfoAnalyte,
                                selectedInfoCharacteristics, infoCharacteristics, handleValueInfoCharacteristics,
                                selectedExamSimple, simpleExams, handleValueExamSimple,
                                selectedAnalyteImport, analytesFromExam,
                                tabTypeAnalyte, toggleTypeAnalyte, handleChangeTextP,
                                morphologys, bacteriums, bacteriumsOptions, bacteriumsSelected, handleValueGram, handleValueIdBacterium, print_graph
                            }}
                        />
                        </div>
                    </Card>
                    </div>
                </Col>

                <Col sm="8" className='container-global-zoom pr-4'>
                    {
                        (id_type_analyte === "1" && id_type_precoded_text >= 1) ?
                            <Card>
                                <CardHeader className="analyte-exam-head">
                                    <div className="analyte-exam-head-content">
                                        <div className="analyte-exam-info">
                                            <span className="analyte-exam-label">Examen</span>
                                            <h3 className="analyte-exam-name">{exam.name}</h3>
                                        </div>
                                        <div className="analyte-exam-section">
                                            <span>{txtsection}</span>
                                            <strong>{exam.name_section}</strong>
                                        </div>
                                    </div>
                                </CardHeader>
                                
                                <div className="precode-box-header">
                                    <div className="precode-box-title-wrap">
                                        <div className="precode-box-icon">
                                            <i className="fa fa-list-ul"></i>
                                        </div>

                                        <div className="precode-box-title-copy">
                                            <span className="precode-box-label">
                                                Textos precodificados
                                            </span>

                                            <p>
                                                Agrega o elimina los textos que deseas utilizar.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="precode-box-badge">
                                        <strong>{selected?.length || 0}</strong>
                                        <span>seleccionados</span>
                                    </div>
                                </div>
                                <Col sm="12">
                                    <Row>
                                        <Col sm="12">
                                            <DualListBox
                                                selected={selected}//el que va a la derecha
                                                simpleValue={false}
                                                onChange={onChange}
                                                filterPlaceholder={"Buscar..."}
                                                showNoOptionsText={true}
                                                canFilter options={data}//izquierda
                                                lang={{
                                                    moveAllLeft: 'Remover todas las opciones',
                                                    moveAllRight: 'Agregar todas las opciones',
                                                    moveLeft: 'Remover la opción seleccionada',
                                                    moveRight: 'Agregar la opcion seleccionada',
                                                    moveBottom: 'Move to bottom',
                                                    noAvailableOptions: 'No hay más textos precodificados disponibles',
                                                    noSelectedOptions: 'No se ha seleccionado ningún texto precodificado',
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <br />

                            </Card>
                            :
                            <Card className="shadow">
                                <div className="exam-header-modern">
                                    <div className="exam-main-info">

                                        <div className="exam-icon">
                                            <i className="fa fa-flask"></i>
                                        </div>

                                        <div className="exam-text">

                                            <span className="exam-small-label">
                                                Examen
                                            </span>

                                            <h6 className="exam-title">
                                                {exam.name}
                                            </h6>

                                            <div className="exam-section">
                                                <span>{txtsection}:</span>
                                                <strong>{exam.name_section}</strong>
                                            </div>

                                        </div>

                                    </div>

                                    <div className="exam-actions">
                                        <Button
                                            type="button"
                                            className="exam-btn"
                                            onClick={handleViewGlobalReference}
                                        >
                                            <i className="fa fa-list-alt"></i>

                                            {viewGlobalReferenceValue
                                                ? "Listado de analitos"
                                                : "Valor de referencia global"}
                                        </Button>

                                        <Button
                                            type="button"
                                            className="exam-btn"
                                            onClick={handleModalOrder}
                                        >
                                            <i className="fa fa-sort"></i>
                                            Ordenar analitos
                                        </Button>

                                        <Button
                                            type="button"
                                            className="exam-btn"
                                            onClick={handleModalOrderPrint}
                                        >
                                            <i className="fa fa-print"></i>
                                            Ordenar impresión
                                        </Button>

                                        <Button
                                            type="button"
                                            className="exam-btn-back"
                                            onClick={() => history.goBack()}
                                        >
                                            <i className="icofont icofont-arrow-left"></i>
                                            Regresar
                                        </Button>

                                    </div>

                                    </div>
                                <CardBody className='pl-4'>
                                    {
                                        viewGlobalReferenceValue ?
                                            <GlobalReferenceValue examId={id_exam}                                                            
                                            />
                                            :

                                            loadingAnalytes ?
                                                <>
                                                    Cargando... &nbsp;<Spinner size="sm" />
                                                </>
                                                :
                                                analytes.length > 0 ?
                                                    <Row>

                                                        <div className="d-flex align-items-center mb-3" style={{ position: "relative", width: "100%" }}>
                                                            <div
                                                                className="ribbon ribbon-clip ribbon-primary"
                                                                style={{ position: "static", flexShrink: 0 }}
                                                            >
                                                                Listado de Analitos
                                                            </div>

                                                            <div style={{ flex: 1 }} />

                                                            <span className="p-input-icon-left" style={{ width: "230px" }}>
                                                                {/* <i className="pi pi-search" /> */}
                                                                <InputText
                                                                    type="search"
                                                                    // value={searchAnalytes}
                                                                    // onChange={(e) => handleSearchAnalytes(e.target.value)}
                                                                    placeholder="Búsqueda..."
                                                                    style={{ width: "100%" }}
                                                                />
                                                            </span>

                                                        </div>

                                                        <div style={{ width: "100%", overflowX: "hidden" }}>
                                                            <DataTable
                                                                value={analytes}
                                                                expandedRows={expandedRowsAnalytes}
                                                                onRowToggle={(e) => setExpandedRowsAnalytes(e.data)}
                                                                rowExpansionTemplate={rowExpansionTemplateAnalytes}
                                                                dataKey="id_analyte"
                                                                className="data-table p-datatable-striped p-datatable-sm"
                                                                style={{ width: "100%" }}
                                                            >
                                                                <Column
                                                                    header="#"
                                                                    body={(rowData, options) => options.rowIndex + 1}
                                                                    headerStyle={headerStyle}
                                                                    style={{ ...centerStyle, width: "5%" }}
                                                                />

                                                                <Column
                                                                    field="name"
                                                                    header="Analito"
                                                                    headerStyle={headerStyle}
                                                                    style={{ ...centerStyle, width: "15%" }}
                                                                />

                                                                <Column
                                                                    field="code"
                                                                    header="Código"
                                                                    headerStyle={headerStyle}
                                                                    style={{ ...centerStyle, width: "15%" }}
                                                                />

                                                                <Column
                                                                    field="name_type_analyte"
                                                                    header="Tipo de resultado"
                                                                    headerStyle={headerStyle}
                                                                    style={{ ...centerStyle, width: "25%" }}
                                                                />

                                                                <Column
                                                                    header="Tipo"
                                                                    body={(rowData) => rowData.is_analyte ? "Sí" : "No"}
                                                                    headerStyle={headerStyle}
                                                                    style={{ ...centerStyle, width: "10%" }}
                                                                />

                                                                <Column
                                                                    header="Acciones"
                                                                    body={actionsAnalytes}
                                                                    exportable={false}
                                                                    headerStyle={headerStyle}
                                                                    style={{ ...centerStyle, width: "30%" }}
                                                                />
                                                            </DataTable>
                                                        </div>

                                                        <Button
                                                            type="button"
                                                            color="secondary"
                                                            
                                                            className={"btn-analito mt-2" + (loading ? "disabled progress-bar-animated progress-bar-striped" : "")}
                                                            onClick={saveAnalytes}
                                                        >
                                                            Guardar analitos
                                                        </Button>
                                                    </Row>
                                                    :
                                                    <>
                                                        <div style={{ textAlign: "-webkit-center" }}>
                                                            <img className="img-fluid" src={require("../../../../assets/images/loginHelenLabs/Alerts/Alert.svg")} style={{ width: "35%" }} alt="" />   <br />
                                                            <br /> <p className="f-18">{"0 Análitos agregados."}</p>
                                                        </div>
                                                    </>
                                    }
                                </CardBody>
                            </Card>
                    }
                </Col>
            </Row>
            <ModalAnalytes
                {...{ modal, toggleModal, nameAnalyte, loadingModal, deleteAnalyte }}
            />
            <ModalTestFormula
                {...{
                    toggleTest, modalTest, loadingTest, testearFormula, compute,
                    init_range, end_range, value, increment, handleInputTest, resetTest, results, resetResults
                }}
            />
            <Modal {...modalProps} padding={false} className="containerZ"  >
                {
                    // TODO:estoy armando el modal para los puros rangos, estoy pasando la variable de "method" y debo continuar con es Daniel del futuro, no te estreses.
                    activeModal === "modalRangos" ?
                        (<ModalRange
                            {...{
                                name, gender, init_value, end_value, years_from, months_from, days_from, years_to, months_to, days_to, text_range,
                                handleInputRange, resetRange, validacionesRange, method, methods, id_type_analyte,
                                id_type_precoded_text, precodedTexts, listRanges, addAnalyteNumberRange, removeAnalyteNumberRange, saveTempAnalytesNumberRanges, editAnalyteNumberRange,
                                saveEditAnalyteRangeNumber, methodActiveRange, backToCreateRange,
                                id_analyte_age_gender_range, handleInputRangePrecoded,
                                listRangesPrecoded, addRangePrecoded, saveTempRangePrecoded, removeRangePrecoded, editRangePrecoded, saveEditRangePrecoded, methodActiveRangePrecoded, backToCreateRangePrecoded,
                                saveTempAnalytesNumberAlerts, listReferenceValues,
                                saveTempAnalytesTextAlerts, listReferenceTexts,
                                tabTypeAnalyte, toggleTypeAnalyte
                            }}
                        />)
                        :
                        <ModalComplex
                            {...{
                                analytesAvailables, refreshFormComplex, responseComplexText, refreshResultComplex, preSavedFormComplex, analytesComplex, exams, exam, methodActive, name
                            }}
                        />
                }
            </Modal>
            {
                modalOrder &&

                <ModalOrderAnalytes
                    {...{
                        analytesGroup, modalOrder, loadingOrder, handleModalOrder, saveOrderAnalytes
                    }}
                />
            }
            {
                modalOrderPrint &&

                <ModalOrderPrintAnalytes
                    {...{
                        analytesGroupPrint, modalOrderPrint, loadingOrderPrint, handleModalOrderPrint, saveOrderPrintAnalytes
                    }}
                />
            }
        </>
    )
}
